import React from 'react';
import { Box, List, Text } from 'bumbag';

import Ugent from '@medipass/react-core/components/Ugent';

import chromeLocationIcon from 'legacy/images/chrome-location-icon.png';
import firefoxLocationIcon from 'legacy/images/firefox-location-icon.png';
export default function LocationPermissionInstructions() {
  return (
    <Box>
      <Ugent browser="chrome" device="computer">
        <List listStyleType="disc" listStylePosition="inside">
          <List.Item>
            Press on the location icon{' '}
            <img
              src={chromeLocationIcon}
              alt="location"
              style={{
                width: '20px',
              }}
            />{' '}
            in your address bar
          </List.Item>
          <List.Item>
            Press on the <Text fontWeight="semibold">Manage</Text> button
          </List.Item>
          <List.Item>
            Remove Tyro Health from the <Text fontWeight="semibold">Block</Text> list
          </List.Item>
        </List>
      </Ugent>
      <Ugent browser="firefox" device="computer">
        <List listStyleType="disc" listStylePosition="inside">
          <List.Item>
            Press on the location icon{' '}
            <img
              src={firefoxLocationIcon}
              alt="location"
              style={{
                width: '20px',
              }}
            />{' '}
            in your address bar
          </List.Item>
          <List.Item>
            Click the cross icon <i className="fa fa-times" /> next to{' '}
            <Text fontWeight="semibold">Access Your Location</Text>
          </List.Item>
        </List>
      </Ugent>
      <Ugent browser="safari" device="computer">
        <List listStyleType="disc" listStylePosition="inside">
          <List.Item>
            Click on <Text fontWeight="semibold">Websites</Text>
          </List.Item>
          <List.Item>
            Click on <Text fontWeight="semibold">Location</Text> in the side bar.
          </List.Item>
          <List.Item>
            Set <Text fontWeight="semibold">medipass.io</Text> to <Text fontWeight="semibold">Allow</Text>
          </List.Item>
        </List>
      </Ugent>
      <Ugent os="ios">
        <List listStyleType="disc" listStylePosition="inside">
          <List.Item>
            Go to{' '}
            <Text fontWeight="semibold">
              Settings {'>'} Privacy {'>'} Location Services
            </Text>
          </List.Item>
          <List.Item>
            Make sure <Text fontWeight="semibold">Location Services is toggled on</Text>
          </List.Item>
          <List.Item>
            Scroll down and <Text fontWeight="semibold">select your browser application</Text>
          </List.Item>
          <List.Item>
            Select the option: <Text fontWeight="semibold">While Using the App</Text>
          </List.Item>
          <List.Item>
            Return to this browser and select <Text fontWeight="semibold">Go back and try again</Text>
          </List.Item>
        </List>
      </Ugent>
      <Ugent os="android">
        <List listStyleType="disc" listStylePosition="inside">
          <List.Item>
            To the right of the address bar, tap <Text fontWeight="semibold">More</Text>, and then{' '}
            <Text fontWeight="semibold">Settings</Text>
          </List.Item>
          <List.Item>
            Tap <Text fontWeight="semibold">Site Settings {'>'} Location</Text>
          </List.Item>
          <List.Item>
            <Text fontWeight="semibold">Turn Location on</Text>
          </List.Item>
          <List.Item>
            Return to this browser and select <Text fontWeight="semibold">Go back and try again</Text>
          </List.Item>
        </List>
      </Ugent>
    </Box>
  );
}
